import type {ReactElement} from 'react';
import React from 'react';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {ColorFillPropertyType} from '@Components/color-fill';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import type {TranscriptSentenceTextColorOptionProps} from './transcript-sentence-text-color-option.types';
import {useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem';

export function TranscriptSentenceTextColorOption({...props}: TranscriptSentenceTextColorOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptSentenceTextColorOption');
  }

  const fillType = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillType');
  if (fillType === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillType property in their sentenceTextStyles object');
  }

  const fillColor = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillColor');
  if (fillColor === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillColor property in their sentenceTextStyles object');
  }

  const getFillType = (): ColorFillPropertyType => {
    if (fillType === FillTypes.LINEAR_GRADIENT) {
      return ColorFillPropertyType.LINEAR;
    }

    if (fillType === FillTypes.RADIAL_GRADIENT) {
      return ColorFillPropertyType.RADIAL;
    }

    return ColorFillPropertyType.SOLID;
  };

  return (
    <ContextualMenuColorFillOption
      id="transcript-sentence-text-color-option"
      label={window.i18next.t('pmwjs_text_color')}
      data={[
        {
          id: 'transcript-sentence-color-object',
          fillType: getFillType(),
          color: getColorObjectArrayFromFillColor(fillColor),
        },
      ]}
      onClick={() => {
        props.onSentenceTextColorFillClick();
      }}
    />
  );
}
